package ui.composables

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.ic_book
import thewedding_cmp.composeapp.generated.resources.ic_pause
import thewedding_cmp.composeapp.generated.resources.ic_play
import ui.theme.ColorScheme
import utils.AudioPlayer

@Composable
fun WeddingFloatingButton(
    audioPlayer: AudioPlayer,
    modifier: Modifier = Modifier
) {
    var showDialog by remember { mutableStateOf(false) }
    var isPlaying by remember { mutableStateOf(true) }

    Box(
        modifier = modifier
            .fillMaxSize()
            .padding(18.dp, 24.dp),
        contentAlignment = Alignment.BottomEnd
    ) {
        Column(
            modifier = Modifier.align(Alignment.BottomEnd),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FloatingActionButton(
                onClick = {
                    if (isPlaying) {
                        audioPlayer.pause()
                    } else {
                        audioPlayer.play()
                    }
                    isPlaying = !isPlaying
                },
                modifier = Modifier.size(40.dp),
                shape = CircleShape,
                containerColor = ColorScheme.primary
            ) {
                Icon(
                    painter = painterResource(
                        if (isPlaying) Res.drawable.ic_pause
                        else Res.drawable.ic_play
                    ),
                    contentDescription = "Play / Pause",
                    modifier = Modifier.size(20.dp)
                )
            }

            Spacer(modifier.size(6.dp))

            FloatingActionButton(
                onClick = {
                    showDialog = true
                },
                modifier = Modifier.size(52.dp),
                shape = CircleShape,
                containerColor = ColorScheme.primary
            ) {
                Icon(
                    painter = painterResource(Res.drawable.ic_book),
                    contentDescription = "Love Story",
                    modifier = Modifier.size(26.dp)
                )
            }
        }
    }
    LoveStoryDialog(
        show = showDialog,
        onDismiss = { showDialog = false }
    )
}
